const CustomColors = {
    primary: '#378F6E',
    primaryLight: '#46A380',
    secondary: '#E3CA98',
    secondaryLight: '#F4EAD6',
    whiteTwo: '#FDF9F3',
};

export default CustomColors;
